export class StartPollingIDVerificationStatus {
  static readonly type = '[IDVerificationDetail] Start Polling ID Verification Status';
}

export class StopPollingIDVerificationStatus {
  static readonly type = '[IDVerificationDetail] Stop Polling ID Verification Status';
}

export class ClearIDVerificationState {
  static readonly type = '[IDVerificationDetail] Clear ID Verification State';
}

export class SetTimedOutState {
  static readonly type = '[IDVerificationDetail] Set ID Verification Timeout';
}
